import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
	searchParam,
	pageNumber,
	status,
	date,
	updatedAt,
	showAll,
	queueIds,
	withUnreadMessages,
    tags,
    channel,
}) => {
	const [loading, setLoading] = useState(true);
	const [hasMore, setHasMore] = useState(false);
	const [tickets, setTickets] = useState([]);

	useEffect(() => {
		setLoading(true);
		const delayDebounceFn = setTimeout(() => {
			const fetchTickets = async () => {
				try {
					const { data } = await api.get("/chats", {
						params: {
							searchParam,
							pageNumber,
							status,
							date,
							updatedAt,
							showAll,
							queueIds,
							withUnreadMessages,
							tags,
							channel,
						},
					});
					setTickets(data.tickets);
					setHasMore(data.hasMore);
					setLoading(false);
				} catch (err) {
					setLoading(false);
					toastError(err);
				}
			};
			fetchTickets();
		}, 500);
		return () => clearTimeout(delayDebounceFn);
	}, [
		searchParam,
		pageNumber,
		status,
		date,
		updatedAt,
		showAll,
		queueIds,
		withUnreadMessages,
		tags,
		channel,
	]);

	return { tickets, loading, hasMore };
};

export default useTickets;
